import { v5 } from 'uuid';
const MY_NAMESPACE = '1b671a64-40d5-491e-99b0-da01ff1f3341';
export const portfolioPhotos = [
  {
    id: v5('portfolio-photo1', MY_NAMESPACE),
    imgBigSize: './photos/blondProfileBigSize.jpg',
    imgSmallSize: './photos/blondProfileSmallSize.jpg',
    title: 'profile of a blond model',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo2', MY_NAMESPACE),
    imgBigSize: './photos/bluePink2BigSize.jpg',
    imgSmallSize: './photos/bluePink2SmallSize.jpg',
    title: 'Model on the illuminated stairs',
    category: 'session',
  },
  {
    id: v5('portfolio-photo3', MY_NAMESPACE),
    imgBigSize: './photos/brownHairBigSize.jpg',
    imgSmallSize: './photos/brownHairSmallSize.jpg',
    title: 'Model in white top',
    category: 'fashion',
  },
  {
    id: v5('portfolio-photo4', MY_NAMESPACE),
    imgBigSize: './photos/brownHairCoatBigSize.jpg',
    imgSmallSize: './photos/brownHairCoatSmallSize.jpg',
    title: 'Model in winter coat',
    category: 'fashion',
  },
  {
    id: v5('portfolio-photo5', MY_NAMESPACE),
    imgBigSize: './photos/brownLongHairBigSize.jpg',
    imgSmallSize: './photos/brownLongHairSmallSize.jpg',
    title: 'Model in blouse',
    category: 'session',
  },
  {
    id: v5('portfolio-photo6', MY_NAMESPACE),
    imgBigSize: './photos/pearlsBigSize.jpg',
    imgSmallSize: './photos/pearlsSmallSize.jpg',
    title: 'Model with pearls',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo7', MY_NAMESPACE),
    imgBigSize: './photos/leafsBigSize.jpg',
    imgSmallSize: './photos/leafsSmallSize.jpg',
    title: 'Model in forest',
    category: 'session',
  },
  {
    id: v5('portfolio-photo8', MY_NAMESPACE),
    imgBigSize: './photos/tattooBigSize.jpg',
    imgSmallSize: './photos/tattooSmallSize.jpg',
    title: 'Model with small tattoo',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo9', MY_NAMESPACE),
    imgBigSize: './photos/lightsBigSize.jpg',
    imgSmallSize: './photos/lightsSmallSize.jpg',
    title: 'Model',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo10', MY_NAMESPACE),
    imgBigSize: './photos/blondProfileBigSize.jpg',
    imgSmallSize: './photos/blondProfileSmallSize.jpg',
    title: 'profile of a blond model',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo11', MY_NAMESPACE),
    imgBigSize: './photos/bluePink2BigSize.jpg',
    imgSmallSize: './photos/bluePink2SmallSize.jpg',
    title: 'Model on the illuminated stairs',
    category: 'session',
  },
  {
    id: v5('portfolio-photo12', MY_NAMESPACE),
    imgBigSize: './photos/brownHairBigSize.jpg',
    imgSmallSize: './photos/brownHairSmallSize.jpg',
    title: 'Model in white top',
    category: 'fashion',
  },
  {
    id: v5('portfolio-photo13', MY_NAMESPACE),
    imgBigSize: './photos/brownHairCoatBigSize.jpg',
    imgSmallSize: './photos/brownHairCoatSmallSize.jpg',
    title: 'Model in winter coat',
    category: 'fashion',
  },
  {
    id: v5('portfolio-photo14', MY_NAMESPACE),
    imgBigSize: './photos/brownLongHairBigSize.jpg',
    imgSmallSize: './photos/brownLongHairSmallSize.jpg',
    title: 'Model in blouse',
    category: 'session',
  },
  {
    id: v5('portfolio-photo15', MY_NAMESPACE),
    imgBigSize: './photos/pearlsBigSize.jpg',
    imgSmallSize: './photos/pearlsSmallSize.jpg',
    title: 'Model with pearls',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo16', MY_NAMESPACE),
    imgBigSize: './photos/leafsBigSize.jpg',
    imgSmallSize: './photos/leafsSmallSize.jpg',
    title: 'Model in forest',
    category: 'session',
  },
  {
    id: v5('portfolio-photo17', MY_NAMESPACE),
    imgBigSize: './photos/tattooBigSize.jpg',
    imgSmallSize: './photos/tattooSmallSize.jpg',
    title: 'Model with small tattoo',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo18', MY_NAMESPACE),
    imgBigSize: './photos/lightsBigSize.jpg',
    imgSmallSize: './photos/lightsSmallSize.jpg',
    title: 'Model',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo19', MY_NAMESPACE),
    imgBigSize: './photos/blondProfileBigSize.jpg',
    imgSmallSize: './photos/blondProfileSmallSize.jpg',
    title: 'profile of a blond model',
    category: 'studio',
  },
  {
    id: v5('portfolio-photo20', MY_NAMESPACE),
    imgBigSize: './photos/bluePink2BigSize.jpg',
    imgSmallSize: './photos/bluePink2SmallSize.jpg',
    title: 'Model on the illuminated stairs',
    category: 'session',
  },
  {
    id: v5('portfolio-photo21', MY_NAMESPACE),
    imgBigSize: './photos/brownHairBigSize.jpg',
    imgSmallSize: './photos/brownHairSmallSize.jpg',
    title: 'Model in white top',
    category: 'fashion',
  },
];
